import { forwardRef } from 'react';

import clsx from 'clsx';

// Hooks
import useAcl from '@/hooks/user/useAcl';

import PropTypes from 'prop-types';

import Icon from '@/components/base/Icon';
// Components
import Label from '@/components/base/Label';
import Radio from '@/components/base/Radio';
import Tooltip from '@/components/base/Tooltip';

const RadioGroupRef = (
    {
        label = '',
        values = [],
        current = '',
        className = 'w-full mb-8',
        labelClassName = '',
        columnList = false,
        tooltip,
        ...restProps
    },
    ref
) => {
    const { hasAcl } = useAcl();

    const hasAccess = (item) => {
        if (item.permissions) {
            return hasAcl(item.permissions);
        }

        return true;
    };

    return (
        <div className={className}>
            {label || tooltip ? (
                <div className="mb-3 flex items-center space-x-3.5">
                    <Label className="!mb-0 max-w-max">{label}</Label>
                    {tooltip ? (
                        <Tooltip placement="top" content={tooltip}>
                            <Icon
                                icon="help"
                                className="text-xs text-icoGray-400 dark:text-icoDarkMode-wolf"
                            />
                        </Tooltip>
                    ) : null}
                </div>
            ) : null}
            <div
                className={clsx('flex', {
                    'mt-5 w-full items-center space-x-8': !columnList,
                    'flex-col gap-y-2.5': columnList
                })}>
                {values?.map((item, key) => {
                    if (hasAccess(item)) {
                        return (
                            <div
                                className={clsx('flex', {
                                    'items-center justify-center': !columnList,
                                    'items-start': columnList
                                })}
                                key={key}>
                                <Label
                                    htmlFor={item.id}
                                    fontType="radio"
                                    className={clsx(
                                        'mb-0 flex cursor-pointer items-center text-icoGray-500 checked:text-icoBlue',
                                        {
                                            'w-auto': columnList,
                                            'ml-2': !columnList
                                        }
                                    )}>
                                    <Radio
                                        className="mr-3"
                                        id={item.id}
                                        name={item.name}
                                        value={item.value}
                                        checked={item.value === current}
                                        ref={ref}
                                        {...restProps}
                                    />
                                    <span className={labelClassName}>{item.label}</span>
                                </Label>
                            </div>
                        );
                    }
                })}
            </div>
        </div>
    );
};

export const RadioGroup = forwardRef(RadioGroupRef);

RadioGroup.propTypes = {
    label: PropTypes.string,
    values: PropTypes.array,
    current: PropTypes.string,
    className: PropTypes.string,
    labelClassName: PropTypes.string,
    columnList: PropTypes.bool,
    tooltip: PropTypes.string
};
